import { CustomerOrderInput } from '../../graphql';

const requiredFields: readonly (keyof CustomerOrderInput)[] = [
	'items',
	'pickupLocation',
	'subtotal',
	'taxAmount',
	'total',
	'payment'
];

export const isCustomerOrderInput = (
	input: Partial<CustomerOrderInput>
): input is CustomerOrderInput =>
	requiredFields.every(field => input[field] !== undefined);
